import React from 'react';
interface CtaProps {
  children: React.ReactNode;
  variant?: 'solid' | 'outline';
  className?: string;
}
export function Cta({
  children,
  variant = 'solid',
  className = ''
}: CtaProps) {
  const base = 'mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl px-6 py-4 text-center text-base font-bold leading-tight transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:text-lg';
  const styles = variant === 'solid' ? 'bg-verde-500 text-white shadow-verde hover:bg-verde-600 focus-visible:outline-verde-700' : 'border border-brand-300 bg-surface text-brand-700 hover:bg-brand-50 focus-visible:outline-brand-600';
  return <a href="#checkout" className={`${base} ${styles} ${className}`} data-id="element-103" data-mp="1nbmr4z6k9dvn">
      {children}
    </a>;
}